import { render } from "./HomeText.vue?vue&type=template&id=4cc38c9c"
import script from "./HomeText.vue?vue&type=script&lang=js"
export * from "./HomeText.vue?vue&type=script&lang=js"

import "./HomeText.vue?vue&type=style&index=0&id=4cc38c9c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__